import { render, staticRenderFns } from "./HighlightedMessage.vue?vue&type=template&id=7c8e7745&scoped=true"
import script from "./HighlightedMessage.vue?vue&type=script&lang=js"
export * from "./HighlightedMessage.vue?vue&type=script&lang=js"
import style0 from "./HighlightedMessage.vue?vue&type=style&index=0&id=7c8e7745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8e7745",
  null
  
)

export default component.exports